import ProductItemDeskTopRegular from "./ProductItemDeskTopRegular";
import ProductItemDeskTopMarket from "./ProductItemDeskTopMarket";

const ProductItemDeskTop = (props) => {
    // מחליט איזה קומפוננט להציג לפי סוג התפריט
    return props.isMarket ? 
        <ProductItemDeskTopMarket {...props} /> : 
        <ProductItemDeskTopRegular {...props} />;
}

export default ProductItemDeskTop;